import { localeScope } from ".";
import { t } from "@/i18n-js/instance";
import { useIsNewOnboardingFlow } from "@circle-react/components/OnboardingPage/hooks/useIsNewOnboardingFlow";
import { Spinner } from "@circle-react-shared/uikit/TipTap/VoiceMessage/components/Spinner";
import { Button } from "@circle-react-uikit/Button";

export interface FooterProps {
  isDisabled: boolean;
  isLoading: boolean;
}

export const Footer = ({ isDisabled, isLoading }: FooterProps) => {
  const { onboardingButtonVariant } = useIsNewOnboardingFlow();
  const shouldBeDisabled = isLoading || isDisabled;

  return (
    <div className="mt-12 w-full text-center">
      <div className="mx-auto flex w-full justify-end">
        <Button
          disabled={shouldBeDisabled}
          variant={onboardingButtonVariant}
          type="submit"
          className="disabled:bg-brand disabled:text-brand-button"
          large
        >
          {isLoading ? (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          ) : (
            t(`${localeScope}.form.buttons.next`)
          )}
        </Button>
      </div>
    </div>
  );
};
